import { BoxProperties } from './BoxProperties';
import { updateShapeProperties } from '../action/actionCreators';

import { connect } from 'react-redux';

const mapStateToProps = function(items, id){
  return {
    item: items.itemList[id.id],
  };
};

const mapDispatchToProps = dispatch => ({
  updateShapeProperties: id => dispatch(updateShapeProperties(id)),
});

export default connect(
  mapStateToProps, 
  mapDispatchToProps
)(BoxProperties);



// WEBPACK FOOTER //
// ./src/components/VisibleBoxProperties.js